import clsx from "clsx";
import { Loading } from "src/_components";
import { formatUrl } from 'src/_helpers'
export const Avata = (props) => {
  return (
    <div
      className={clsx({
        "a-avatar": true,
      })}
      {...props}
    >
      <div className="image-loading position-center">
        <Loading type="ring" />
      </div>
      <img
        className={clsx({
          "position-center": true,
        })}
        src={formatUrl(props.src || "/static/images/no-img.png")}
        alt=""
      />
      <img
        className={clsx({
          "image-placeholder": true,
        })}
        src={formatUrl("/static/images/no-img.png")}
        alt=""
      />
    </div>
  );
};
